import React, {memo} from 'react';

import {withTryCatch} from 'coreUtils/reactUtils';

import ShowOrHideOnBreakpoint from 'brandComponents/Responsive/ShowOrHideOnBreakpoint';

import {INavigationItemOldProps} from './IFlatNavigationItem';

const FlatNavigationItemContainer = (props: INavigationItemOldProps) => {
	return (
		<>
			{props.root}

			<ShowOrHideOnBreakpoint classNames="sublists" query="<xx-large">
				{props.children}
			</ShowOrHideOnBreakpoint>
		</>
	);
};

export default memo(withTryCatch(FlatNavigationItemContainer), () => true);
